import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Navigation from 'components/Layout/Navigation/Navigation';
import closeMenu from 'assets/images/ModalClose.svg';
import { toggleMenu } from 'helpers/Helpers';
import {
  Logo,
  TelephoneGreen,
  MailGreen,
} from '../../../assets/images/index.js';
import ReactGA from 'react-ga';

export default class Header extends Component {
  render() {
    ReactGA.initialize('UA-55299362-8');
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <header className='header'>
        <div className='wrapper pt30'>
          <div className='header-info'>
            <div className='flexcenter'>
              <TelephoneGreen />
              <a href='tel:+31174622668' className='ml5 pr16'>
                0174 - 622 668
              </a>
            </div>
            <div className='flexcenter'>
              <MailGreen />
              <a href='mailto:hallo@foreverplants.nl' className='ml5'>
                hallo@foreverplants.nl
              </a>
            </div>
          </div>
          <div className='navigation-container'>
            <div
              className='hamburger-icon'
              onClick={(e) => toggleMenu('mb-nav-wrapper')}
            >
              <span />
              <span />
              <span />
            </div>
            <Link to='/' className='header-logo outline-none'>
              <Logo />
            </Link>
            <div className='mb-nav-wrapper' id='mb-nav-wrapper'>
              <div className='mb-nav-header'>
                <p>Menu</p>
                <div
                  className='mb-toggle-off'
                  onClick={(e) => toggleMenu('mb-nav-wrapper')}
                >
                  <img src={closeMenu} alt='close' />
                </div>
              </div>
              <Navigation />
            </div>
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Includes/Header.jsx